module.exports = __webpack_public_path__ + "media/images/creator/home/kv-4e9080d638f872ebe4e769387717f950.png";